import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_vhUQYXjAF',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '7aqiq61eraisicqbrnmam77gau',
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN || 'bri-auth-dev-583865559711.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [import.meta.env.VITE_OAUTH_CALLBACK_URL || 'http://localhost:3000/auth/callback'],
          redirectSignOut: [import.meta.env.VITE_OAUTH_LOGOUT_URL || 'http://localhost:3000/auth/logout'],
          responseType: 'code' as const,
        },
        email: true,
      },
    },
  },
};

// Configure Amplify
Amplify.configure(awsConfig);

export default awsConfig;
